import { Box, Paper } from "@mui/material";
import React from "react";
import DataTableComponent from "../../../components/common/DataTable/DataTable";

export default function UnderReviewData({ filteredRows, newProductColumns }) {
  return (
    <Box>
      {filteredRows?.length > 0 && (
        <Box sx={{ display: "contents" }}>
          <Paper
            sx={{
              width: "100%",
              border: "1px solid #E5E5E8",
              borderRadius: "4px",
            }}
          >
            <DataTableComponent
              data={filteredRows || []}
              columns={newProductColumns}
              customStyles={{
                table: {
                  style: {
                    borderCollapse: "collapse",
                  },
                },
                headCells: {
                  style: {
                    borderRight: "1px solid rgba(229, 229, 232, 1)",
                  },
                },
                cells: {
                  style: {
                    borderRight: "1px solid rgba(229, 229, 232, 1)",
                  },
                },
              }}
            />
          </Paper>
        </Box>
      )}
    </Box>
  );
}
